import React, {useState} from 'react';
import {
	Row,
	Col, FormGroup, Label, Input, Popover, PopoverBody
} from "reactstrap";

const APICredential = () =>
{
	const [credentialType, setCredentialType] = useState("-1");
	const [popoverOpen, setPopoverOpen] = useState(false);
	const showForm = (e) =>
	{
		setPopoverOpen(false);
		setCredentialType(e.target.value);
	};

	const handleConfirmation = (e) =>
	{
		if (e.target.value !== document.getElementById("passwordId").value)
		{
			setPopoverOpen(true);
		} else setPopoverOpen(false);
	};

	return (
		<>
			<Row form>
				<Col md={6}>
					<FormGroup>
						<Label for="credentialTypeId">Credential Type</Label>
						<Input type="select" name="credentialTypeId" id="credentialTypeId" onChange={showForm}>
							<option value="-1">Select an authentication method</option>
							<option value="0">API Key client credentials (Key and Secret)</option>
							<option value="1">Client certificate</option>
							<option value="2">User and Password</option>
						</Input>
					</FormGroup>
				</Col>
			</Row>

			{
				(credentialType === "0") &&
				(
					<Row form>
						<Col md={6}>
							<FormGroup>
								<Label for="clientId">Client Id</Label>
								<Input type="text" name="clientId" id="clientId"/>
							</FormGroup>
						</Col>
						<Col md={6}>
							<FormGroup>
								<Label for="secretKeyId">Secret key</Label>
								<Input type="text" maxLength="250" name="secretKeyId" id="secretKeyId"/>
							</FormGroup>
						</Col>
					</Row>
				)
			}

			{
				(credentialType === "1") &&
				<Row form>
					<Col md={6}>
						<FormGroup>
							<Label for="merchantId">MerchantId</Label>
							<Input type="text" name="merchantId" id="merchantId"/>
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<Label for="certificate">Certificate</Label>
							<Input type="textarea" name="certificate" id="certificate"/>
						</FormGroup>
					</Col>
				</Row>
			}

			{
				(credentialType === "2") &&
				(<>
						<Row form>
							<Col md={6}>
								<FormGroup>
									<Label for="userId">User</Label>
									<Input type="text" name="userId" id="userId"/>
								</FormGroup>
							</Col>
						</Row>
						<Row form>
							<Col md={6}>
								<FormGroup>
									<Label for="passwordId">Password</Label>
									<Input type="password" name="passwordId" id="passwordId"/>
								</FormGroup>
							</Col>
							<Col md={6}>
								<FormGroup>
									<Label for="passwordConfirmationId">Password confirmation</Label>
									<Input type="password" name="passwordConfirmationId" id="passwordConfirmationId" onChange={handleConfirmation}/>
									<Popover placement="bottom" isOpen={popoverOpen} target="passwordConfirmationId">
										<PopoverBody><i className="fas fa-exclamation-triangle text-warning"/> Passwords do not match</PopoverBody>
									</Popover>
								</FormGroup>
							</Col>
						</Row>
					</>
				)
			}
		</>
	);
}

export default APICredential;